import { Component } from '@angular/core';

@Component({
    selector: 'ca-form-error-message',
    templateUrl: './form-error-message.component.html',
    styleUrls: ['./form-error-message.component.scss'],
    standalone: false
})
export class FormErrorMessageComponent {}
